import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AppHeader from '../components/AppHeader';
import { SCREENS } from '../components/reference/screens';
import { useAuthStore } from '../store/authStore';
import { buyersApi } from '../services/referenceApi';
import type { BuyerSummary } from '../services/referenceApi';


/** For Logic Ag staff: every buyer, with a way into its reference data. */
function BuyerList() {
  const [buyers, setBuyers] = useState<BuyerSummary[] | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    buyersApi
      .list()
      .then(({ data }) => {
        if (!cancelled) setBuyers(data);
      })
      .catch(() => {
        if (!cancelled) setError('We could not load the buyers just now. Check your connection and try again.');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="mt-10">
      <h2 className="text-heading text-ink">Buyers</h2>
      {error && (
        <p role="alert" className="mt-3 text-body text-danger">
          {error}
        </p>
      )}
      {buyers === null && !error && (
        <p className="mt-3 text-body text-ink-muted" role="status">
          Loading buyers
        </p>
      )}
      {buyers !== null && buyers.length === 0 && <p className="mt-3 text-body text-ink-muted">No buyers yet.</p>}
      {buyers !== null && buyers.length > 0 && (
        <ul className="mt-4 divide-y divide-line border-y border-line">
          {buyers.map((buyer) => (
            <li key={buyer.slug} className="flex flex-wrap items-center justify-between gap-4 py-3">
              <span className="text-body font-semibold text-ink">{buyer.name}</span>
              <nav aria-label={`${buyer.name} reference data`} className="flex flex-wrap gap-x-4 gap-y-2">
                {SCREENS.map((s) => (
                  <Link
                    key={s.path}
                    to={`/buyers/${buyer.slug}/${s.path}`}
                    className="text-caption font-semibold text-navy underline-offset-4 hover:underline"
                  >
                    {s.label}
                  </Link>
                ))}
              </nav>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

export default function Home() {
  const role = useAuthStore((s) => s.user?.role);

  return (
    <div className="min-h-screen">
      <AppHeader />
      <main className="mx-auto max-w-5xl px-4 py-12">
        <h1 className="text-display text-ink">MerchantView</h1>
        <p className="mt-3 text-body text-ink-muted">The coverage board arrives here next.</p>
        {role && role !== 'buyer' && <BuyerList />}
      </main>
    </div>
  );
}
